// extracted by mini-css-extract-plugin
export default {"wrapper":"e1-z","play":"f1-z"};